import { useEffect, useState } from 'react';
import { supabase } from '../../supabase';

export default function Users() {
  console.log('[Users.jsx] mounted');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState(null);

  const load = async (searchTerm = '') => {
    setLoading(true);
    let q = supabase.from('profiles').select('*').order('created_at', { ascending: false }).limit(50);
    if (searchTerm.trim()) {
      const term = searchTerm.trim();
      q = q.or(`name.ilike.%${term}%,phone.ilike.%${term}%`);
    }
    const { data } = await q;
    setUsers(data || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const onSearch = (e) => {
    e.preventDefault();
    load(query);
  };

  return (
    <div>
      <div style={S.headerRow}>
        <h1 style={S.h1}>Users</h1>
        <form onSubmit={onSearch} style={S.searchRow}>
          <input
            style={S.search}
            placeholder="Search by name or phone…"
            value={query}
            onChange={e => setQuery(e.target.value)}
          />
          <button type="submit" style={S.searchBtn}>Search</button>
        </form>
      </div>

      {loading ? <p style={S.dim}>Loading…</p> :
        users.length === 0 ? <p style={S.dim}>No users found.</p> :
        <table style={S.table}>
          <thead>
            <tr style={S.tr}>
              <th style={S.th}>Name</th>
              <th style={S.th}>Phone</th>
              <th style={S.th}>Age</th>
              <th style={S.th}>Rep</th>
              <th style={S.th}>Status</th>
              <th style={S.th}>Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id} style={{...S.tr, cursor: 'pointer'}} onClick={() => setSelected(u)}>
                <td style={{...S.td, color: '#fff'}}>{u.name || '(no name)'}</td>
                <td style={S.td}>{u.phone || '—'}</td>
                <td style={S.td}>{u.age || '—'}</td>
                <td style={S.td}>{u.score_visible ? u.rep_score : 'NEW'}</td>
                <td style={S.td}>
                  {u.banned && <span style={S.statusBan}>BANNED</span>}
                  {!u.banned && u.verified && <span style={S.statusVerified}>VERIFIED</span>}
                  {!u.banned && !u.verified && u.onboarding_complete && <span style={S.statusActive}>ACTIVE</span>}
                  {!u.onboarding_complete && <span style={S.statusPending}>ONBOARDING</span>}
                </td>
                <td style={S.td}>{new Date(u.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      }

      {selected && (
        <div style={S.modalBg} onClick={() => setSelected(null)}>
          <div style={S.modal} onClick={e => e.stopPropagation()}>
            <h2 style={S.h2}>{selected.name || '(no name)'}</h2>
            <p style={S.dim}>Joined {new Date(selected.created_at).toLocaleString()}</p>

            {selected.selfie_url && <img src={selected.selfie_url} alt="selfie" style={S.selfie} />}

            <Field label="Phone" value={selected.phone} />
            <Field label="Email" value={selected.email} />
            <Field label="Age" value={selected.age} />
            <Field label="Pronouns" value={selected.pronouns} />
            <Field label="Gender" value={selected.gender} />
            <Field label="Show me" value={selected.show_me} />
            <Field label="Intention" value={selected.intention} />
            <Field label="Bio" value={selected.bio} />
            <Field label="ZIP" value={selected.zip} />
            <Field label="Tags" value={(selected.tags || []).join(', ')} />
            <Field label="Dealbreakers" value={(selected.dealbreakers || []).join(', ')} />
            <Field label="Photos" value={`${(selected.photos || []).length} photo(s)`} />
            <Field label="Rep score" value={selected.score_visible ? `${selected.rep_score} (${selected.rep_count} ratings)` : 'Not yet visible (< 3 ratings)'} />
            <Field label="Verified" value={selected.verified ? 'Yes' : 'No'} />
            <Field label="Banned" value={selected.banned ? `Yes — ${selected.banned_reason || 'no reason'}` : 'No'} />
            <Field label="Onboarding" value={selected.onboarding_complete ? 'Complete' : `Step: ${selected.onboarding_step}`} />

            {selected.photos && selected.photos.length > 0 && (
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
                {selected.photos.map((url, i) => (
                  <img key={i} src={url} alt={`item ${i}`} style={S.photoThumb} />
                ))}
              </div>
            )}

            <button style={S.cancel} onClick={() => setSelected(null)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

function Field({ label, value }) {
  if (value === null || value === undefined || value === '') return null;
  return (
    <div style={{ display: 'flex', borderBottom: '1px solid rgba(255,255,255,0.05)', padding: '8px 0' }}>
      <div style={{ width: 130, fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: 1 }}>{label}</div>
      <div style={{ flex: 1, fontSize: 13, color: '#fff' }}>{String(value)}</div>
    </div>
  );
}

const S = {
  h1: { fontSize: 28, fontWeight: 800, margin: 0 },
  h2: { fontSize: 22, fontWeight: 800, margin: '0 0 4px 0' },
  dim: { color: '#888', fontSize: 13, margin: '4px 0' },
  headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, gap: 16 },
  searchRow: { display: 'flex', gap: 8 },
  search: { background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 999, color: '#fff', padding: '8px 16px', fontSize: 13, width: 260, outline: 'none' },
  searchBtn: { background: 'rgba(167,139,250,0.15)', border: '1px solid rgba(167,139,250,0.3)', color: '#a78bfa', padding: '8px 18px', borderRadius: 999, fontSize: 13, fontWeight: 700, cursor: 'pointer' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tr: { borderBottom: '1px solid rgba(255,255,255,0.06)' },
  th: { textAlign: 'left', padding: '12px 16px', color: '#888', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1 },
  td: { padding: '14px 16px', color: '#aaa', fontSize: 13 },
  statusBan: { background: 'rgba(248,113,113,0.15)', color: '#f87171', padding: '3px 10px', borderRadius: 4, fontSize: 10, fontWeight: 800 },
  statusVerified: { background: 'rgba(52,211,153,0.15)', color: '#34d399', padding: '3px 10px', borderRadius: 4, fontSize: 10, fontWeight: 800 },
  statusActive: { background: 'rgba(255,255,255,0.05)', color: '#aaa', padding: '3px 10px', borderRadius: 4, fontSize: 10, fontWeight: 800 },
  statusPending: { background: 'rgba(251,191,36,0.15)', color: '#fbbf24', padding: '3px 10px', borderRadius: 4, fontSize: 10, fontWeight: 800 },
  modalBg: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: 20 },
  modal: { background: '#1a0a2e', borderRadius: 16, maxWidth: 600, width: '100%', maxHeight: '90vh', overflow: 'auto', padding: 28 },
  selfie: { width: 120, height: 120, borderRadius: 60, objectFit: 'cover', marginTop: 12, marginBottom: 12 },
  photoThumb: { width: 80, height: 80, borderRadius: 8, objectFit: 'cover' },
  cancel: { width: '100%', padding: 10, marginTop: 24, background: 'none', border: '1px solid rgba(255,255,255,0.1)', color: '#888', fontSize: 13, cursor: 'pointer', borderRadius: 999 },
};
